import styles from "./product-analogue.module.scss";
import { t } from "i18next";
import { useGonePageCommon } from "@/pages-react/gone-page/gone-page-common.tsx";
import { Icon } from "@/elements-react/fix-icon";
import triangle from "@/assets/triangle.svg";
import { LayoutStyleTypes, LayoutTypes, useLayoutType } from "@/util-react/layout.tsx";
import classNames from "classnames";
import { ProductPageStore, useProductPageCommon } from "@/pages-react/product-page/ProductPageCommon.tsx";

export const ProductAnaloguePage = (props: { store: ProductPageStore; layout: LayoutTypes }) => {
  const { mpn, renderCanBe } = useProductPageCommon(props.layout, props.store);
  const { renderForm } = useGonePageCommon(mpn);
  const { layoutStyleType } = useLayoutType();

  return (
    <div className={classNames(styles.container, styles[layoutStyleType])}>
      <div className={styles.label}>
        {mpn} {t("A3584E94A0A6B76E.no-longer-available", "is no longer available")}
      </div>
      <div className={styles["sub-text"]}>{t("d8gj5n22tuwie3uf.we-can-offer-analogues", "We can offer you analogues which also might fit your vehicle:")}</div>
      <div className={styles["analogues"]}>
        <Icon className={styles["analogues-icon"]} src={triangle} width={24} />
        {renderCanBe(LayoutStyleTypes.TYPE_LG)}
      </div>
      <div className={styles["form"]}>{renderForm()}</div>
    </div>
  );
};
